import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './languages/en'
import fr from './languages/fr'
import de from './languages/de'
import useLanguage from '../hooks/useLanguage'

const language = useLanguage()

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  fr: { translation: { ...fr } },
  en: { translation: { ...en } },
  de: { translation: { ...de } },
}

i18n.use(initReactI18next).init({
  resources,
  debug: false,
  fallbackLng: 'en',
  lng: language?.replace('_', '-') || navigator.language,
  keySeparator: '.',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
